import MultiselectDataTable from './MultiselectDataTable';

export * from './MultiselectDataTable';
export default MultiselectDataTable;
